export default __webpack_public_path__ + "static/media/Euroceramica.253370ad.svg";